var eventPopup = {
  load:function(){
    this.layout();
  },
  layout:function(){
    this.popup = document.createElement("div");
    this.popup.classList.add("eventPopup");





    this.popupContent = document.createElement("div");
    this.popupContent.classList.add("eventPopupContent");
    this.popup.append(this.popupContent);

    this.popupClose = document.createElement("div");
    this.popupClose.innerHTML = 'CLOSE <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Close</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>';
    this.popupClose.classList.add("eventPopupClose");
    this.popupClose.addEventListener("click",(e)=>{
      e.preventDefault();
      this.close();
    });
    this.popupContent.append(this.popupClose);

    this.popupContentHolder = document.createElement("div");
    //this.popupIframe.src = ELAJAX.homeurl+"/blank/";
    this.popupContentHolder.classList.add("contentHolder");
    this.popupContent.append(this.popupContentHolder);


    document.body.appendChild(this.popup);

    this.popup.addEventListener("click",(e)=>{
      if(e.target !== e.currentTarget) return;
      this.close();
    });
  },
  showEvent:function(eventHash,event=false){
    if(event){
      event.preventDefault();

    }
    this.popupContentHolder.innerHTML = '<div class="eventLoader"><div class="eventLoaderHolder"><div class="elLoader"><div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>LOADING EVENT</div></div>';
    var formData = new FormData;
    formData.append('action','eventlisting');
    formData.append('eventHash',eventHash);
    fetch(ELAJAX.ajaxURL,{
      method:"POST",
      body:formData
    }).then(res=>res.text())
    .then(data=>{
      this.popupContentHolder.innerHTML = data;
      eventListing.load(eventHash);
    });

    this.popup.classList.add('show');
    document.body.style.overflowY = "hidden";
  },
  close:function(){
    this.popup.classList.remove('show');
    document.body.style.overflowY = "auto";
  }
};
